import { SetStateAction } from "react";
import { ModalWithButtons } from "./modal";
import { BlueButton, WhiteButton } from "../button";
import { useTranslation } from "react-i18next";
import { NeutralColor } from "node-library/dist/colors";

interface Props {
	open: boolean;
	setOpen: React.Dispatch<SetStateAction<boolean>>;
	setUnsavedChanges: React.Dispatch<SetStateAction<boolean>>;
	proceedAction: () => void;
}

export default function UnsavedChangesModal(props: Props) {
	const { t: translation } = useTranslation();

	const modal: React.ReactNode = (
		<ModalWithButtons
			headerText={""}
			open={props.open}
			setOpen={props.setOpen}
			buttons={[
				<WhiteButton
					key="unsaved-changes-proceed-button"
					id="unsaved-changes-proceed-button"
					children={translation("Leavepage")}
					onClick={() => {
						props.setUnsavedChanges(false);
						setTimeout(() => props.proceedAction(), 1);
						props.setOpen(false);
					}}
				></WhiteButton>,
				<BlueButton
					key="unsaved-changes-cancel-button"
					id="unsaved-changes-cancel-button"
					children={translation("Cancel")}
					onClick={() => {
						props.setOpen(false);
					}}
				></BlueButton>,
			]}
		>
			<div className="modal-body-content">
				<div className="modal-body-icon-small unsaved-changes-icon"></div>

				<div className="typography-body-01 typography-bold">
					{translation("UnsavedChanges")}
				</div>
				<div
					className="typography-body-01"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("UnsavedChangesMessage")}
				</div>
				<div
					className="typography-body-01"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("UnsavedChangesMessageProceed")}
				</div>
			</div>
		</ModalWithButtons>
	);

	return modal;
}
